function pxToVh(px) {
    return (px / document.documentElement.clientHeight) * 100;
}

function formatVhString(v) {
    return 'calc(var(--vh) * ' + v + ')';
}

function formatPxString(px) {
    return `${px}px`;
}

export { pxToVh, formatVhString, formatPxString };
